<div class="dialog-container">
  <div class="dialog-body">
    <img
      [src]="images.REVERT_ICON"
      [alt]="'REVERT_ORDER.REVERT_ICON' | translate"
    />
    <div class="title">{{ 'REVERT_ORDER.REVERT_ORDER' | translate }}</div>
    <div class="description">
      {{ 'REVERT_ORDER.REVERT_ORDER_DESC' | translate }}
    </div>
  </div>
  <div class="dialog-footer flex_sb">
    <button class="btn cancel-btn" (click)="cancelClicked()">
      {{ 'REVERT_ORDER.CANCEL' | translate }}
    </button>
    <button class="btn revert-btn" (click)="revertClicked()">
      {{ 'REVERT_ORDER.YES_REVERT' | translate }}
    </button>
  </div>
</div>
